import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LocalStorageKeys } from '../core/enums/LocalStorageKeys';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class TimezoneService {


  private timezone = new BehaviorSubject<string>(this.loadFromStorage());

  constructor(private LocalStorageService: LocalStorageService) { }


  // Detectar la xzona del navegador la primera vez
  private loadFromStorage(): string {
    const stored = this.LocalStorageService.get<string>(LocalStorageKeys.Timezone)
    let result = stored || Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    return result == "Europe/London" ? result : "Europe/Madrid"
  }

  setTimezone(tz: string): void {
    this.timezone.next(tz);
    this.LocalStorageService.set(LocalStorageKeys.Timezone, tz)
  }

  getTimezone(): Observable<string> {
    return this.timezone.asObservable();
  }

  getCurrentTimezone(): string {
    return this.timezone.value;
  }
}
